module.exports = __webpack_public_path__ + "static/media/step1.6ee91b11.svg";